import { render } from "./Coupon.vue?vue&type=template&id=2beea268&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=ts"
export * from "./Coupon.vue?vue&type=script&lang=ts"

import "./Coupon.vue?vue&type=style&index=0&id=2beea268&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2beea268"

export default script